exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#footer[data-v-5b9f392f]{position:relative;z-index:0}.footer-color[data-v-5b9f392f]{color:#939da3}.link[data-v-5b9f392f]:hover{color:#6f7c82}.footer-copyright[data-v-5b9f392f]{margin-right:100px}", ""]);
